module.exports = __webpack_public_path__ + "static/media/pinhatas@2x.43d5462a.jpg";